import * as React from 'react';

import { Modal, ModalBody } from 'reactstrap';

import Localization from '../../config/localization';

import ARondSvg from '../Svg/aRond';
import CloseSvg from '../Svg/close';
import PhoneSvg from '../Svg/phone';
import PostalSvg from '../Svg/postal';
import PrinterSvg from '../Svg/printer';

import './Contact.scss';

class Contact extends React.Component<Contact.IProps, Contact.IState> {
  render() {
    return (
      <Modal isOpen={this.props.isOpen} centered toggle={this._onClick} className="contact">
        <ModalBody className="m-3 mb-2">
          <div className="d-flex mb-3">
            <h4 className="eon-title h-100 my-auto mr-auto">{Localization.contactModalTitle}</h4>
            <CloseSvg className="c-pointer" onClick={this._onClick} />
          </div>
          <div className="d-flex">
            <ARondSvg className="my-2" />
            <p className="eon-title my-auto h-100">{`${Localization.contactModalEmailLabel} ${Localization.contactModalEmail}`}</p>
          </div>
          <div className="d-flex">
            <PhoneSvg className="my-2" />
            <p className="eon-title my-auto h-100">{`${Localization.contactModalPhoneLabel} ${Localization.contactModalPhone}`}</p>
          </div>
          <div className="d-flex">
            <PrinterSvg className="my-2" />
            <p className="eon-title my-auto h-100">{`${Localization.contactModalFaxLabel} ${Localization.contactModalFax}`}</p>
          </div>
          <div className="d-flex">
            <PostalSvg className="my-2" />
            <p className="eon-title my-auto h-100">{`${Localization.contactModalPostalLabel} ${Localization.contactModalPostal}`}</p>
          </div>
          <div className="mt-4">
            <p className="eon-title my-auto h-100 c-pointer eon-red" onClick={this._onClick}>
              {Localization.contactModalClose}
            </p>
          </div>
        </ModalBody>
      </Modal>
    );
  }

  _onClick = (event?: React.MouseEvent<HTMLParagraphElement>) => {
    if (event && event.preventDefault) event.preventDefault();

    return this.props.onClose();
  };
}

export default Contact;
